/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does converting case change my original text?`)
};

const es_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Convierte casos mi texto original?`)
};

const de_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändert die Case-Konvertierung meinen ursprünglichen Text?`)
};

const nl_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verandert het omzetten van zaak mijn originele tekst?`)
};

const fr_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conversion de casse modifie-t-elle mon texte d'origine ?`)
};

const it_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conversione di maiuscole cambia il mio testo originale?`)
};

const pt_br2_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter caso altera meu texto original?`)
};

const pt_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A conversão de casos altera meu texto original?`)
};

const ja_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケースを変換すると元のテキストが変わりますか？`)
};

const zh_cc_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换大小写会改变我的原始文本吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq4_q", locale)
	if (locale === "en") return en_cc_faq4_q(inputs)
	if (locale === "es") return es_cc_faq4_q(inputs)
	if (locale === "de") return de_cc_faq4_q(inputs)
	if (locale === "nl") return nl_cc_faq4_q(inputs)
	if (locale === "fr") return fr_cc_faq4_q(inputs)
	if (locale === "it") return it_cc_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq4_q(inputs)
	if (locale === "pt") return pt_cc_faq4_q(inputs)
	if (locale === "ja") return ja_cc_faq4_q(inputs)
	return zh_cc_faq4_q(inputs)
};